import Loading from './Loading';

type LoadingLayoutProps = {
    isLoading?: boolean;
};
const LoadingLayout = ({ isLoading }: LoadingLayoutProps) => (
    <>
        {!!isLoading && (
            <div className="absolute z-40 top-[45%] left-[45%] bg-white px-4 py-2 rounded-full shadow-lg">
                <Loading />
            </div>
        )}
    </>
);

export default LoadingLayout;
